"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.grabAllImageUrls = void 0;
var axios_1 = __importDefault(require("axios"));
var BlockTokenTraverser_1 = require("@CommonFrontendBackend/Blocks/BlockTokenTraverser");
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var isSplashBlock = function (block) {
    return block.type === BlockTypes_1.BlockType.Splash && block.resourceType === "image";
};
var isImageToken = function (token) {
    return token.subType === "image";
};
var isOverLimit = function (listLength, limit) {
    return listLength >= limit;
};
var isUnique = function (image, imageUrls) {
    return !imageUrls.includes(image);
};
var collateImageUrls = function (blocks, limit) {
    var imageUrls = [];
    var blockTokenTraverser = new BlockTokenTraverser_1.BlockTokenTraverser();
    blocks.forEach(function (block) {
        var e_1, _a, e_2, _b;
        if (isOverLimit(imageUrls.length, limit)) {
            return;
        }
        if (isSplashBlock(block) && isUnique(block.resourceUrl, imageUrls)) {
            imageUrls.push(block.resourceUrl);
        }
        try {
            for (var _c = __values(blockTokenTraverser.traverseBlockForTokens(block)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var tokens = _d.value;
                if (isOverLimit(imageUrls.length, limit)) {
                    break;
                }
                try {
                    for (var tokens_1 = (e_2 = void 0, __values(tokens)), tokens_1_1 = tokens_1.next(); !tokens_1_1.done; tokens_1_1 = tokens_1.next()) {
                        var token = tokens_1_1.value;
                        if (isOverLimit(imageUrls.length, limit)) {
                            break;
                        }
                        if (isImageToken(token) && isUnique(token.src, imageUrls)) {
                            imageUrls.push(token.src);
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (tokens_1_1 && !tokens_1_1.done && (_b = tokens_1.return)) _b.call(tokens_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
    });
    return imageUrls;
};
var grabAllImageUrls = function (id, limit, apiBaseUrl) { return __awaiter(void 0, void 0, Promise, function () {
    var results, allUrls;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.get("".concat(apiBaseUrl, "/projects/").concat(id, "/blocks"), {
                    withCredentials: true,
                })];
            case 1:
                results = _a.sent();
                allUrls = collateImageUrls(results.data, limit);
                return [2, allUrls];
        }
    });
}); };
exports.grabAllImageUrls = grabAllImageUrls;
